export default "__VITE_ASSET__XUx6VtFW__"